import Immutable from 'immutable';
import { STATUS } from './constants';

export const getCourseByLessonId = (state, lessonId) =>
  state.lessons.getIn(
    ['coursesByLessonId', `${lessonId}`, 'data'],
    Immutable.Map()
  );

export const getCourseByLessonIdStatus = (state, lessonId) =>
  state.lessons.getIn(
    ['coursesByLessonId', `${lessonId}`, 'status'],
    STATUS.UNINITIALIZED
  );

export const getLessonByLessonId = (state, lessonId) =>
  state.lessons.getIn(['lessons', `${lessonId}`, 'data'], Immutable.Map());

export const getLessonStatusByLessonId = (state, lessonId) =>
  state.lessons.getIn(
    ['lessons', `${lessonId}`, 'status'],
    STATUS.UNINITIALIZED
  );

export const getQuizAttemptsByLessonId = (state, lessonId) =>
  state.lessons.getIn(
    ['quizAttemptsByLessonId', `${lessonId}`, 'data'],
    Immutable.List()
  );

export const getQuizAttemptsByLessonIdStatus = (state, lessonId) =>
  state.lessons.getIn(
    ['quizAttemptsByLessonId', `${lessonId}`, 'status'],
    STATUS.UNINITIALIZED
  );

// collates quizAttempts from all loaded lessons and filters down to relevant questionIds
export const getQuizAttemptsByQuestionId = (state, questionId) => {
  return state.lessons
    .get('quizAttemptsByLessonId')
    .toList()
    .filter((item) => item.get('status') === STATUS.READY)
    .flatMap((item) => item.get('data'))
    .filter((quizAttempt) => quizAttempt.get('question') == questionId)
    .sortBy((quizAttempt) => quizAttempt.get('attempted_ts'));
};

export const getQuizStatsByQuestionId = (state, questionId) => {
  return state.lessons.getIn(['quizStatsByQuestionId', `${questionId}`], null);
};

export const getQuizStatsByLessonIdStatus = (state, lessonId) => {
  return state.lessons.getIn(
    ['quizAttemptsByLessonId', `${lessonId}`, 'status'],
    STATUS.UNINITIALIZED
  );
};

export const getQuizStatsByQuestionIdStatus = (state, questionId) => {
  // retrieve loading status from lesson via lesson_id normalised on quizStat
  const quizStats = getQuizStatsByQuestionId(state, questionId);
  return getQuizStatsByLessonIdStatus(state, quizStats.get('lesson_id'));
};

export const getChunkVisitsByLessonId = (state, lessonId) => {
  return state.lessons.getIn(
    ['chunkVisitsByLessonId', `${lessonId}`, 'data'],
    Immutable.List()
  );
};

export const getChunkVisitsByLessonIdStatus = (state, lessonId) => {
  return state.lessons.getIn(
    ['chunkVisitsByLessonId', `${lessonId}`, 'status'],
    STATUS.UNINITIALIZED
  );
};

export const getSuccessMeasureResponsesByLessonId = (state, lessonId) => {
  return state.lessons.getIn(
    ['successMeasureResponsesByLessonId', `${lessonId}`, 'data'],
    Immutable.List()
  );
};

export const getSuccessMeasureResponseFailureReason = (
  state,
  successMeasureId
) => {
  return state.lessons.getIn([
    'successMeasureResponsesSaving',
    `${successMeasureId}`,
    'failureReason',
  ]);
};

export const getSuccessMeasureResponseRequestStatus = (
  state,
  successMeasureId
) => {
  return state.lessons.getIn([
    'successMeasureResponsesSaving',
    `${successMeasureId}`,
  ]);
};
